module.exports = __webpack_public_path__ + "be0583398df8fcb55eaf48264e255f20.svg";